export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            联系我们
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            欢迎投稿爆料、商务合作或咨询交流
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="rounded-2xl bg-background-50 border border-background-200/70 p-8 md:p-10">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
              {[
                {
                  icon: 'ri-mail-send-line',
                  title: '投稿爆料',
                  desc: '欢迎提供独家黑料线索，编辑团队审核后择优发布',
                  action: '发送邮件',
                  href: '#contact',
                },
                {
                  icon: 'ri-briefcase-line',
                  title: '商务合作',
                  desc: '广告投放、品牌合作、内容授权等商务洽谈',
                  action: '立即洽谈',
                  href: '#contact',
                },
                {
                  icon: 'ri-question-answer-line',
                  title: '咨询反馈',
                  desc: '使用问题、意见建议等，我们将尽快回复',
                  action: '提交反馈',
                  href: '#contact',
                },
              ].map((item) => (
                <div key={item.title} className="text-center p-5 rounded-xl bg-background-100 border border-background-200/70">
                  <div className="w-11 h-11 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mx-auto mb-3">
                    <i className={`${item.icon} text-lg`}></i>
                  </div>
                  <h3 className="font-heading text-sm font-bold text-foreground-900 mb-2 whitespace-nowrap">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 leading-relaxed mb-4">
                    {item.desc}
                  </p>
                  <a
                    href={item.href}
                    className="inline-block px-5 py-2 rounded-lg bg-primary-500 text-white text-xs font-label font-semibold whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
                  >
                    {item.action}
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}